import { createAction, props } from '@ngrx/store';
import { EmployeeGroupPermission } from '@fc-core';

export const loadGroupPermissions = createAction(
  '[GroupPermissions] Load Group Permissions',
  props<{ groupId: number }>(),
);

export const loadGroupPermissionsSuccess = createAction(
  '[GroupPermissions] Load Group Permissions Success',
  props<{ data: EmployeeGroupPermission[] }>(),
);

export const loadGroupPermissionsFailure = createAction(
  '[GroupPermissions] Load Group Permissions Failure',
  props<{ error: any }>(),
);

export const addGroupPermission = createAction(
  '[GroupPermissions] Add Group Permission',
  props<{ groupId: number; permissionId: number }>(),
);

export const addGroupPermissionSuccess = createAction(
  '[GroupPermissions] Add Group Permission Success',
  props<{ groupId: number; permissionId: number }>(),
);

export const removeGroupPermission = createAction(
  '[GroupPermissions] Remove Group Permission',
  props<{ groupId: number; permissionId: number }>(),
);

export const removeGroupPermissionSuccess = createAction(
  '[GroupPermissions] Remove Group Permission Success',
  props<{ groupId: number; permissionId: number }>(),
);
